import { EventBus } from "../../../eventbus";

export default {
  props: {
    title: String,
    color: String,
    icon: String,
    leftBtns: {
      type: Array,
      default: () => [],
    },
    rightBtns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultLeftBtns: this.leftBtns,
      defaultRightBtns: this.rightBtns,
    };
  },
  created() {
    //listen for changes in top options
    this.addListeners();
  },
  methods: {
    addListeners() {
      const emitters = [];
      [...this.defaultLeftBtns, ...this.defaultRightBtns].forEach((btn) => {
        //listen for emitters from btns
        if (btn.emitterName) {
          if (!emitters.includes(btn.emitterName)) {
            emitters.push(btn.emitterName);

            EventBus.$on(btn.emitterName, this.updateBtnStatus);
          }
        }
      });
    },

    updateBtnStatus(data) {
      if (data.show !== undefined) {
        this.setState(data.id, data.show);
      }
    },

    handleClick(btn, e) {
      e.preventDefault();

      //complete event
      if (btn.to) {
        //is link
        this.goTo(btn.to);
      } else if (btn.emitterName) {
        //is emitter
        this.emit(btn.emitterName, btn.emitterData);
      }
    },
    setState(id, status) {
      this.defaultLeftBtns = this.setActive(this.defaultLeftBtns, id, status);
      this.defaultRightBtns = this.setActive(this.defaultRightBtns, id, status);
    },
    setActive(btnArray, id, status) {
      return btnArray.map((btn) => {
        return {
          ...btn,
          btnSettings:
            id === btn.id
              ? {
                  ...btn.btnSettings,
                  active:
                    status === "toggle" ? !btn.btnSettings.active : status,
                }
              : { ...btn.btnSettings, active: false },
        };
      });
    },

    goTo(link) {
      this.$router.push(link);
    },
    emit(name, data) {
      EventBus.$emit(name, data);
    },
  },
  watch: {
    title() {},
    leftBtns() {
      this.defaultLeftBtns = this.leftBtns;
    },
    rightBtns() {
      this.defaultRightBtns = this.rightBtns;
    },
  },
};
